import { IPageProps } from 'portal/src/layouts/LayoutPreference/layoutTypes';
import Page from 'portal/src/layouts/Page';

export default function BillAutomationPage(
  props: IPageProps,
): React.ReactElement {
  return <Page {...props} />;
}
